'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeProductForm = require('@shopify/theme-product-form');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Variables
var pathName = window.location.pathname;

var currentID;

var lastScrollTop = 0;

// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener("scroll", function () {
  // or window.addEventListener("scroll"....
  var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
  if (st > lastScrollTop) {
    // downscroll code

    $('body').removeClass('scrolling');
  } else {
    // upscroll code
    $('body').addClass('scrolling');
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);

//
// $(document).on('click', 'a[href^=/#]', function(e) {
//   e.preventDefault();
//   var id = $(this).attr('href').replace('/', '');
//   $('html,body').animate({
//     scrollTop: $(id).offset().top
//   }, 500);
// });


$(document).on('click', '.scroll-to', function (e) {
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $(this).offset().top - 190
  }, 500);
});

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _themeCart.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

function checkWidth() {
  // device detection
  var width = window.innerWidth;
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    return true;
  } else if (width <= 768) {
    return true;
  } else if (width > 768) {
    return false;
  }
}

if (window.location.pathname == '/') {
  console.log('tes');
  if (checkWidth()) {
    $('.template-index').addClass('mobile-home');
  }
}

$(window).on('resize', function () {
  var win = $(this); //this = window
  if (checkWidth()) {
    $('.template-index').addClass('mobile-home');
  } else {
    $('.template-index').removeClass('mobile-home');
  }
});

$(document).on('click', '.burger', function () {
  $('body').toggleClass('open-mobile-nav');
  $('.mainNavMobile').fadeToggle();
});

$(document).on('click', '.dropdown-trigger', function (e) {

  e.preventDefault();
  console.log($(this).parent());
  $(this).parent().toggleClass('active');
});

/*=============================
FIND US
===============================*/

function groupBy(arr, property) {
  return arr.reduce(function (memo, x) {
    if (!memo[x[property]]) {
      memo[x[property]] = [];
    }
    memo[x[property]].push(x);
    return memo;
  }, {});
}

function buildLocationLists() {
  var title;
  var obj;
  var html = '';
  var byState = groupBy(mapLocs, 'state'); // => {orange:[...], banana:[...]}
  var byCity = Object.keys(byState).map(function (item, i) {
    return groupBy(byState[item], 'city'); // => {orange:[...], banana:[...]}
  });

  for (var i = 0; i < byCity.length; i++) {
    title = byCity[i][Object.keys(byCity[i])[0]][0].state;

    html += '\n        <div class="location-list-item location-list-' + title.toLowerCase() + '" data-state="' + title.toLowerCase() + '">\n          <h2 class="underlined"><a>' + title + '</a></h2>\n          <div class="locations">\n          ';

    for (var property in byCity[i]) {
      obj = byCity[i][property];

      html += '\n        <h3>' + property + '</h3>\n        <ul class="cols-3">';

      obj.map(function (item, i) {
        console.log(item);
        html += '\n          <li>\n            <h4>' + item.loc_name + '</h4>\n            <div class="address">\n              ' + item.street + '\n              <br>\n              ' + item.city + ', ' + item.state + ' ' + item.zip + '\n            </div>\n          </li>\n        ';
      });
      html += '</ul>';
    }
    html += '</div></div>';
  }

  $('.location-list').html(html);
}

if (pathName.indexOf('find-us') !== -1) {
  buildLocationLists();
}

$(document).on('click', '.icon-map .hover', function () {
  var state = $(this).attr('data-state');

  $('.location-list-item').hide();
  $('.location-list-' + state).fadeIn();

  var element = $('.location-list');
  $('html, body').animate({
    scrollTop: $(".location-list").offset().top
  }, 500);
});

/*=============================
RECIPE MODAL
===============================*/

var modal;
var overlay;

function buildRecipeModal() {
  var dataSet = this.dataset;
  var modalContainer = document.getElementById('cocktail-modal-container');

  var modal = document.getElementById('cocktail-modal');
  var overlay = document.getElementById('overlay');

  var title = dataSet.title;
  var ingredients = dataSet.ingredients;
  var accessories = dataSet.accessories;
  var preparation = dataSet.preparation;
  var bgImg = dataSet.img;

  var html = '\n              <div class="cols-2 no-gutters">\n                <div class=" txt-container">\n                    <!-- inner container start -->\n                    <div class="inner-container">\n                      <!-- top bar -->\n                      <div class="top-bar"></div>\n                      <div class="scroll-container">\n\n                      <h3 id="cocktail-title" class="underlined"><a href="">' + title + '</a></h3>\n                      <div class="">\n                        ' + (ingredients ? '\n                            <div class="cocktail-ingredients">\n                                <h4>INGREDIENTS</h4>\n                                <div id="ingredients">\n                                  ' + ingredients + '\n                                </div>\n                              </div>\n                            ' : '') + '\n                        ' + (accessories ? '\n                            <div class="cocktail-accessories">\n                              <h4>ACCESSORIES</h4>\n                              <div id="accessories">\n                                ' + accessories + '\n                              </div>\n                            </div>\n                            ' : '') + '\n                      </div>\n                      ' + (preparation ? '\n                          <div class="cocktail-preparation">\n                            <h4>PREPARATION</h4>\n                            <div id="preparation">\n                              ' + preparation + '\n                            </div>\n                          </div>\n                          ' : '') + '\n\n                      <!-- scroll -->\n                      </div>\n\n                      <!-- bottom bar -->\n                      <div class="bottom-bar"></div>\n                    </div>\n                  <!-- inner container end -->\n                </div>\n                <div class="cocktail-modal-img" style="position: relative;">\n                  <div class="modal-close">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24.042" height="24.042" viewBox="0 0 24.042 24.042">\n                      <g id="Group_306" data-name="Group 306" transform="translate(-1080.479 -218.479)">\n                        <line id="Line_17" data-name="Line 17" y2="32" transform="translate(1081.186 219.186) rotate(-45)" fill="none" stroke="#242424" stroke-width="2"/>\n                        <line id="Line_18" data-name="Line 18" x2="32" transform="translate(1081.186 241.814) rotate(-45)" fill="none" stroke="#242424" stroke-width="2"/>\n                      </g>\n                    </svg>\n                  </div>\n                  <img src="' + bgImg + '">\n                </div>\n                <div id="cocktail-bg-img" class="hide cocktail-modal_bg-img" style="background-image: url(\'' + bgImg + '\'); ">\n\n                  <div class="modal-close">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24.042" height="24.042" viewBox="0 0 24.042 24.042">\n                      <g id="Group_306" data-name="Group 306" transform="translate(-1080.479 -218.479)">\n                        <line id="Line_17" data-name="Line 17" y2="32" transform="translate(1081.186 219.186) rotate(-45)" fill="none" stroke="#242424" stroke-width="2"/>\n                        <line id="Line_18" data-name="Line 18" x2="32" transform="translate(1081.186 241.814) rotate(-45)" fill="none" stroke="#242424" stroke-width="2"/>\n                      </g>\n                    </svg>\n                  </div>\n\n\n\n                </div>\n              </div>\n              ';

  modal.innerHTML = html;
  modal.style.display = "block";
  modalContainer.style.display = "block";
  document.body.className += ' scroll-locked';
  var modalClose = document.getElementsByClassName("modal-close");

  for (var i = 0; i < modalClose.length; i++) {
    modalClose[i].addEventListener('click', closeModal, false);
  }

  function closeModal() {
    modal.style.display = "none";
    modalContainer.style.display = "none";
    document.body.className = document.body.className.replace("scroll-locked", "");
  }
}

var cocktailEl = document.getElementsByClassName("cocktails-item");

for (var i = 0; i < cocktailEl.length; i++) {
  cocktailEl[i].addEventListener('click', buildRecipeModal, false);
}

/*=============================
FAQs
===============================*/
function accordion() {
  if (this.classList.contains('active')) {
    this.classList.remove('active');
  } else {
    this.classList.add('active');
  }
}

var accordionEl = document.getElementsByClassName("accordion-trigger");

for (var i = 0; i < accordionEl.length; i++) {
  accordionEl[i].addEventListener('click', accordion, false);
}

/*=============================
SHOPPING
===============================*/

jQuery('.swatch :radio').change(function () {
  var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
  var optionID = jQuery(this).attr('data-option-id');
  var variantID = jQuery(this).attr('data-variant-id');
  var optionValue = jQuery(this).val();
  var handle = $(this).attr('data-product-handle');
  var form = $(this).closest('form');
  var variantTitle = $(this).attr('data-variant-title');
  optionIndex = parseInt(optionIndex) + 1;

  $(form).attr('data-option' + optionIndex, variantTitle);

  $('#Option' + optionIndex + '-' + optionValue + '-' + optionID).trigger('click');
  $('.js-' + optionIndex + '-' + handle).attr('data-value', variantID);
});

$(document).on('click', '.modal-close', function () {});

$(document).on('click', '.quick-shop', function () {
  var index = $(this).attr('data-index');
  if (checkWidth()) {
    if ($(this).hasClass('active')) {
      $('.modal-' + index).fadeIn();
      $('.overlay').fadeIn();
    }

    $(this).addClass('active');
  } else {
    $('.modal-' + index).fadeIn();
    $('.overlay').fadeIn();
  }
});

if (pathName.indexOf('collection') !== -1 || pathName.indexOf('product') !== -1 || pathName.indexOf('cart') !== -1) {

  $(document).ready(function () {
    /* ---------------------------------------------
    Number Input Wrapper
    ------------------------------------------------ */

    $('.number-input-wrapper').find('input[type="number"]').hide();

    $('.number-input-wrapper .add-one, .number-input-wrapper .subtract-one').on('click', function (e) {
      e.preventDefault();

      $('#addToCartBtn').removeClass('inactive');
      var $clickedButton = $(this);
      var $numberInputWrapper = $clickedButton.closest('.number-input-wrapper');
      var $numberInput = $numberInputWrapper.find('input');
      var $placeholder = $numberInputWrapper.find('.placeholder');
      var operation = $clickedButton.data('operation');

      var currentInputValue = parseInt($numberInput.val(), 10);

      if (operation == 'add') {
        $('.subtract-one').show();
      }

      if (operation == 'add' || operation == 'subtract' && currentInputValue > 0) {
        var newValue = operation == 'add' ? currentInputValue + 1 : currentInputValue - 1;
        $numberInput.val(newValue);
        $placeholder.html(newValue);
        if (newValue == 0) {
          $('.subtract-one').hide();
          $('#addToCartBtn').addClass('inactive');
        }
      }
    });
  });
}